import React, { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../features/auth/pages/login';
import ForgotPassword from '../features/auth/pages/ForgotPassword';
import NewPassword from '../features/auth/pages/NewPassword';
import ResetPin from '../features/auth/pages/ResetPin';
import ChangePassword from '../features/auth/pages/ChangePassword';
import SuccessfulPasswordChange from '../features/auth/pages/SuccessfulPasswordChange';
import Unauthorized from '../features/auth/pages/unauthorized';
import Layout from '../layout/Layout';
import { useAuth } from '../context/useAuth';
import PropTypes from 'prop-types';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return user ? children : <Navigate to="/login" replace />;
};

const AppRouter = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/prijava" element={<Navigate to="/login" replace />} />
    <Route path="/zaboravljena-sifra" element={<ForgotPassword />} />
    <Route path="/promenite-sifru" element={<ChangePassword />} />
    <Route path="/nova-sifra" element={<NewPassword />} />
    {/* Link iz mejla "Zaboravljen PIN" (super admin). */}
    <Route path="/novi-pin" element={<ResetPin />} />
    <Route path="/promenjena-sifra" element={<SuccessfulPasswordChange />} />
    <Route path="/neovlascen" element={<Unauthorized />} />
    <Route
      path="/*"
      element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }
    />
  </Routes>
);

PrivateRoute.propTypes = {
  children: PropTypes.node,
};

export default AppRouter;
